import React from "react";
import { Button, Col, Row } from "reactstrap";
import AgencyFilter from "../../Payments/AgencyFilter";
// import PositionTypeFilter from "./PositionTypeFilter";
// import Flatpickr from "react-flatpickr";
import { getYearDateRange } from "common/lib/dateUtils";
import PaymentCategoryFilter from "pages/Payments/PaymentCategoryFilter";
import OffCanvasFilter from "./OffCanvasFilter";

const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 5 }, (_, index) => {
    const year = currentYear - index;
    return { value: year.toString(), label: year.toString() };
  });
};

const Filters = ({
  setSearchValue,
  setPage,
  searchValue,
  setFilterValue,
  filterValue,
  defaultFilterValue,
  setSorted,
}: any) => {
  const [advancedFilter, setAdvancedFilter] = React.useState(false);

  const clearFilters = () => {
    setFilterValue(defaultFilterValue);
    setSearchValue("");
    setPage(1);
    setSorted([{ id: "createdAt", desc: true }]);
  };

  const yearOptions = React.useMemo(() => generateYearOptions(), []);

  return (
    <>
      <Row className="g-3 py-2">
        <Col xxl={4} lg={6}>
          {/* <h6 className="text-uppercase fs-12 mb-2">Search</h6> */}
          <div className="search-box">
            <input
              type="text"
              className="form-control"
              placeholder="Search payments..."
              onChange={(e) => {
                setSearchValue(e.target.value);
                setPage(1);
              }}
              value={searchValue}
            />
            <i className="ri-search-line search-icon"></i>
          </div>
        </Col>
        <Col xxl={2} lg={6}>
          <PaymentCategoryFilter
            onChange={(value: any) => {
              setFilterValue({ ...filterValue, paymentCategory: value });
              setPage(1);
            }}
            value={filterValue.paymentCategory}
          />
        </Col>

        {/* <Col xxl={2} lg={6}>
          <select
            className="form-control"
            data-choices
            data-choices-search-false
            name="choices-single-default2"
            id="choices-single-default2"
            onChange={(e: any) => {
              setFilterValue({
                ...filterValue,
                status: e.target.value,
              });
              setPage(1);
            }}
            value={filterValue.status}
          >
            <option value="">Select Status</option>
            <option value="all">All</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </Col> */}

        <Col xxl={2} lg={6}>
          <select
            className="form-control"
            data-choices
            data-choices-search-false
            name="choices-single-default2"
            id="choices-single-default2"
            onChange={(e) => {
              const { firstDay, lastDay } = getYearDateRange(
                Number(e.target.value)
              );
              setFilterValue({
                ...filterValue,
                year: e.target.value,
                dateRange: {
                  fromDate: new Date(firstDay),
                  toDate: new Date(lastDay),
                },
              });
              setPage(1);
            }}
            value={filterValue.year}
          >
            <option value="">Select Year</option>
            {yearOptions.map((option: any) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </Col>

        <Col xxl={2} lg={6}>
          {/* <h6 className="text-uppercase fs-12 mb-2">Agency</h6> */}
          <AgencyFilter
            onChange={(value: any) => {
              setFilterValue({ ...filterValue, agency: value });
              setPage(1);
            }}
            value={filterValue.agency}
          />
        </Col>
        <Col xxl={2} lg={4}>
          {/* <h6 className="text-uppercase fs-12 mb-xxl-4"> {` `}</h6> */}

          <div className="w-100 d-flex gap-2">
            <button
              className="flex-grow-1 btn btn-light"
              onClick={() => {
                clearFilters();
              }}
            >
              <i className="ri-restart-line align-bottom me-1"></i>
              Reset{" "}
            </button>

            <Button
              color="primary"
              className="flex-grow-1"
              onClick={() => {
                setAdvancedFilter(true);
              }}
            >
              <i className="ri-equalizer-line align-bottom me-1"></i>
              Filters
            </Button>
          </div>

          {/* <ButtonGroup className="material-shadow w-100">
              <Button
                color="primary"
                className=""
                outline
                onClick={() => {
                  setFilterValue(defaultFilterValue);
                  setSearchValue("");
                  setPage(1);
                  setSorted([{ id: "createdAt", desc: true }]);
                }}
              >
                <i className="ri-restart-line align-bottom me-1"></i>
                Reset{" "}
              </Button>

              <Button color="primary" className="" onClick={() => {}}>
                <i className="ri-equalizer-line align-bottom me-1"></i>
                Filters
              </Button>
            </ButtonGroup> */}
        </Col>
      </Row>

      <OffCanvasFilter
        show={advancedFilter}
        onCloseClick={() => setAdvancedFilter(false)}
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        setPage={setPage}
        clearFilters={clearFilters}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
      />
    </>
  );
};

export default Filters;
